import React from 'react'
import styled from 'styled-components'

import { TopHeaderTabs } from './TopHeaderTabs'
import { ProductPicker } from './ProductPicker'
import { useFeature } from '../../store/features'
import { getLogoWrapperPadding } from './utils'
import { getProductPickerMenuItems } from './ProductPickerService'
import SvgIcon from '../design-system/Icon/SvgIcon'
import SwitchEnvironments from '../SwitchEnvironments/components/SwitchEnvironments'
import { Link, LinkProps } from 'react-router-dom'

interface Props {
  hideDesignerSpecific?: boolean
  onDashboard?: boolean
}

interface LogoWrapperProps {
  $disableBorder?: boolean
  $shouldShowProductPicker: boolean
}

export const TopHeader: React.FC<Props> = ({ hideDesignerSpecific, onDashboard }) => {
  const isVoiceBuilderEnabled = !!useFeature('VOICE_BUILDER')
  const shouldShowProductPicker = getProductPickerMenuItems(isVoiceBuilderEnabled).length > 1

  return (
    <TopHeaderWrapper>
      {!!shouldShowProductPicker && <ProductPicker />}

      <LogoWrapper
        $disableBorder={hideDesignerSpecific}
        $shouldShowProductPicker={shouldShowProductPicker}
        to="/"
      >
        <SvgIcon name={'logo'} />
      </LogoWrapper>
      <TopHeaderTabs hideDesignerSpecific={hideDesignerSpecific} />
      {!window.location.href.endsWith('/users') && !onDashboard && <SwitchEnvironments />}
    </TopHeaderWrapper>
  )
}

const LogoWrapper = styled(Link)<LinkProps & LogoWrapperProps>`
  padding: ${props => getLogoWrapperPadding(props.$shouldShowProductPicker)};
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: ${props => !props.$disableBorder && '1px solid #dfe2e5'};
  cursor: pointer;
`

export const TopHeaderWrapper = styled.div`
  display: flex;
  width: 100vw;
  height: ${props => props.theme.topHeader.width};
  justify-content: flex-start;
  background: #fff;
  border-bottom: 1px solid #dfe2e5;
  box-sizing: content-box;
  position: sticky;
  left: 0;
  z-index: 42;
  @media print {
    display: none;
  }
`

export const Divider = styled.div`
  width: 1px;
  height: 36px;
  background: #dfe3e9;
  margin: auto 16px;
`
